import configuration from '../../utilities/configuration';
import OrderModel from "../../models/order/OrderModel";
import OrderBasicModel from "../../models/order/OrderBasicModel";
import OrderOnBehalfModel from "../../models/order/OrderOnBehalfModel";
import * as EffectUtility from "../../utilities/EffectUtility";

export async function requestUserOrders(user) {
    const endpoint = configuration.apiServer + configuration.apiOrdersPath + "/" + user;
    return EffectUtility.getToModel(OrderModel, endpoint);
}

export async function requestAllOrders() {
    const endpoint = configuration.apiServer + configuration.apiOrdersPath;
    return EffectUtility.getToModel(OrderModel, endpoint);
}

export async function requestAllOrdersBasic() {
    const endpoint = configuration.apiServer + configuration.apiOrdersBasicPath;
    return EffectUtility.getToModel(OrderBasicModel, endpoint);
}

export async function requestSpecificOrder(user, orderId) {
    const endpoint = configuration.apiServer + configuration.apiOrdersPath + "/" + user + "/" + orderId;
    return EffectUtility.getToModel(OrderModel, endpoint);
}

export async function updateUserOrder(userId, orderId, params) {
    const endpoint = configuration.apiServer + configuration.apiOrdersPath + "/" + userId + "/" + orderId;
    return EffectUtility.putToModel(OrderModel, endpoint, params);
}

export async function createEmptyOrder(userId, params) {
    const endpoint = configuration.apiServer + configuration.apiOrdersPath + "/" + userId;
    return EffectUtility.postToModel(OrderOnBehalfModel, endpoint, params, true, true);
}

export async function acceptTermsConditions(userId, orderId) {
    const endpoint = configuration.apiServer + configuration.apiOrdersPath + "/" + userId + "/" + orderId + "/accept";
    return EffectUtility.putToModel(OrderModel, endpoint);
}